<div class="p-2 pt-3 bg-white rounded">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="pTitle d-flex justify-content-between">
                    <div class="text-bold">Country-Currency</div>
                    <button class="btn btn-success btn-sm" (click)="addNew(content)">+Add New</button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="table-responsive">
                    <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine" [columnDefs]="columnDefs"
                        [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>

{{ setContent(content) }}

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Country-Currency</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
    </div>
    <div class="modal-body">
        <form #userForm="ngForm">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" name="name" [(ngModel)]="dataObj.name" required>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Status</label>
                            <select class="form-control form-select" name="status" [(ngModel)]="dataObj.status" required>
                                <option value="Active">Active</option>
                                <option value="In-Active">In-Active</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mt-2 text-center">
                        <button [disabled]="!userForm.valid" class="btn btn-primary active mt-4 w-50" (click)="onSubmit(userForm.valid)">Submit</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>